"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleShiftStatus = exports.useSelectedDays = exports.useSelectedShifts = exports.useResources = exports.useGroup = exports.useSchedule = exports.ScheduleProvider = exports.ScheduleContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const utils_1 = require("@bemlo/utils");
const consts_1 = require("./consts");
const useUIShiftsFromSlots_1 = require("./useUIShiftsFromSlots");
Object.defineProperty(exports, "getScheduleShiftStatus", { enumerable: true, get: function () { return useUIShiftsFromSlots_1.getScheduleShiftStatus; } });
const ui_draft_shift_to_shift_1 = require("./utils/ui-draft-shift-to-shift");
const Container = styled_1.default.div(({ isHorizontallyScrollable }) => ({
    overflowX: isHorizontallyScrollable ? 'auto' : 'hidden',
    position: 'relative',
    ...(isHorizontallyScrollable && {
        width: 0,
        flex: 1,
    }),
}));
const initialState = {
    collapsedGroups: [],
    enableEditing: false,
    enableSelectShifts: false,
    enableSelectDays: false,
    isScrolled: false,
    setCollapsedGroups: () => null,
    shiftPopover: undefined,
    availabilityPopover: undefined,
    availableChannels: {
        publishing: true,
        pools: false,
        tenders: true,
    },
    shifts: [],
    availability: [],
    resourcesIdMap: new Map(),
    resourcesRowKeyMap: new Map(),
    startDate: '',
    viewBookings: 'rows',
    startsAt: 0,
    endsAt: 0,
    zoom: 'week',
    headerColumnWidth: 0,
    columnWidth: 0,
    days: [],
    currentDay: null,
    currentWeek: null,
    columnCount: 1,
    containerWidth: 0,
    selectedShifts: undefined,
    setSelectedShifts: undefined,
    selectedDays: undefined,
    setSelectedDays: undefined,
    onCreateDraftShift: () => undefined,
    onDeleteDraftShift: () => undefined,
};
exports.ScheduleContext = react_1.default.createContext(initialState);
const ScheduleProvider = (props) => {
    const [collapsedGroups, setCollapsedGroups] = (0, react_1.useState)([]);
    const draftShifts = props.enableEditing
        ? props.enableEditing.draftShifts.map(ui_draft_shift_to_shift_1.convertUIDraftShiftToShift)
        : utils_1.EMPTY_FROZEN_ARRAY;
    const shifts = [...props.shifts, ...draftShifts];
    const availability = props.availability ?? [];
    const { resourcesIdMap, resourcesRowKeyMap } = (0, react_1.useMemo)(() => {
        if (!props.resources)
            return {
                resourcesIdMap: new Map(),
                resourcesRowKeyMap: new Map(),
            };
        const toResource = (resource) => ({
            rowKey: resource.rowKey,
            id: resource.id,
            fullName: resource.fullName,
            profession: resource.profession,
            homeUnitId: resource.contract?.homeUnitId ?? resource.candidateBooking?.unitId,
        });
        const resourcesIdMap = new Map(props.resources.map((resource) => [resource.id, toResource(resource)]));
        const resourcesRowKeyMap = new Map(props.resources
            .filter((resource) => typeof resource.rowKey === 'number')
            .map((resource) => [resource.rowKey, toResource(resource)]));
        return { resourcesIdMap, resourcesRowKeyMap };
    }, [props.resources]);
    const containerRef = (0, react_1.useRef)(null);
    const [containerWidth, setContainerWidth] = (0, react_1.useState)(0);
    const [isScrolled, setIsScrolled] = (0, react_1.useState)(false);
    const [currentDay, setCurrentDay] = (0, react_1.useState)(props.days[0]);
    (0, react_1.useEffect)(() => {
        setCurrentDay(props.days[0]);
    }, [props.days]);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                const scrollLeft = containerRef.current.scrollLeft;
                if (containerWidth !== containerRef.current.clientWidth) {
                    setContainerWidth(containerRef.current.clientWidth);
                }
                // Update isScrolled state
                if (scrollLeft > 0 && !isScrolled) {
                    setIsScrolled(true);
                }
                else if (scrollLeft === 0 && isScrolled) {
                    setIsScrolled(false);
                }
                const visibleColumnIndex = Math.floor(scrollLeft / consts_1.COLUMN_WIDTH[props.zoom]);
                if (props.days[visibleColumnIndex]) {
                    const dateISO = props.days[visibleColumnIndex].dateISO;
                    if (dateISO !== currentDay.dateISO) {
                        const newDay = props.days.find((day) => day.dateISO === dateISO);
                        if (newDay) {
                            setCurrentDay(newDay);
                        }
                    }
                }
            }
        };
        const throttledHandleScroll = (0, lodash_1.throttle)(handleScroll, 100);
        const container = containerRef.current;
        if (container) {
            setContainerWidth(container.clientWidth);
            container.addEventListener('scroll', throttledHandleScroll);
            return () => {
                container.removeEventListener('scroll', throttledHandleScroll);
            };
        }
    }, [props.days, props.zoom, currentDay]);
    const currentWeek = currentDay
        ? {
            number: currentDay.weekNumber,
            days: props.days
                .filter((day) => day.weekNumber === currentDay.weekNumber)
                .map(({ dateISO }) => dateISO),
        }
        : null;
    return ((0, jsx_runtime_1.jsx)(Container, { ref: containerRef, isHorizontallyScrollable: props.days.length > 7, children: (0, jsx_runtime_1.jsx)(exports.ScheduleContext.Provider, { value: {
                shiftPopover: props.shiftPopover,
                availabilityPopover: props.availabilityPopover,
                enableEditing: !!props.enableEditing,
                enableSelectShifts: !!props.enableSelectShifts,
                enableSelectDays: !!props.enableSelectDays,
                availableChannels: props.availableChannels || {
                    publishing: false,
                    pools: false,
                    tenders: false,
                },
                isScrolled,
                startsAt: props.startsAt,
                endsAt: props.endsAt,
                zoom: props.zoom,
                headerColumnWidth: props.headerColumnWidth,
                columnWidth: consts_1.COLUMN_WIDTH[props.zoom],
                startDate: props.days[0].dateISO,
                days: props.days,
                currentDay,
                currentWeek,
                // Title column + 7 days for each week
                columnCount: 1 + props.days.length,
                containerWidth,
                shifts,
                availability,
                resourcesIdMap,
                resourcesRowKeyMap,
                selectedShifts: (0, utils_1.isTruthy)(props.enableSelectShifts)
                    ? props.enableSelectShifts.selectedShifts
                    : undefined,
                setSelectedShifts: (0, utils_1.isTruthy)(props.enableSelectShifts)
                    ? props.enableSelectShifts.setSelectedShifts
                    : undefined,
                selectedDays: (0, utils_1.isTruthy)(props.enableSelectDays)
                    ? props.enableSelectDays.selectedDays
                    : undefined,
                setSelectedDays: (0, utils_1.isTruthy)(props.enableSelectDays)
                    ? props.enableSelectDays.setSelectedDays
                    : undefined,
                collapsedGroups,
                setCollapsedGroups,
                viewBookings: props.compactBookings ? 'compact' : 'rows',
                onCreateDraftShift: (0, utils_1.isTruthy)(props.enableEditing)
                    ? props.enableEditing.onCreate
                    : undefined,
                onDeleteDraftShift: (0, utils_1.isTruthy)(props.enableEditing)
                    ? props.enableEditing.onDelete
                    : undefined,
            }, children: props.children }) }));
};
exports.ScheduleProvider = ScheduleProvider;
const useSchedule = () => {
    const context = react_1.default.useContext(exports.ScheduleContext);
    if (context === undefined) {
        throw new Error('useSchedule must be used within a ScheduleContextProvider');
    }
    return context;
};
exports.useSchedule = useSchedule;
const useGroup = (id) => {
    const { collapsedGroups, setCollapsedGroups } = useSchedule();
    const isOpen = !collapsedGroups.includes(id);
    const toggleOpen = () => {
        setCollapsedGroups((curr) => {
            if (isOpen)
                return [...curr, id];
            return curr.filter((toggledId) => toggledId !== id);
        });
    };
    return { isOpen, toggleOpen };
};
exports.useGroup = useGroup;
const useResources = (id) => {
    const { resourcesIdMap } = useSchedule();
    return { resources: resourcesIdMap, resource: resourcesIdMap.get(id) };
};
exports.useResources = useResources;
const useSelectedShifts = (ids) => {
    const { selectedShifts, setSelectedShifts, enableSelectShifts } = useSchedule();
    const toggleSelected = () => {
        if (!enableSelectShifts)
            return;
        setSelectedShifts?.((curr) => {
            if (ids.every((id) => curr.includes(id))) {
                return curr.filter((id) => !ids.includes(id));
            }
            return (0, lodash_1.uniq)([...curr, ...ids]);
        });
    };
    const isSelected = ids.some((id) => selectedShifts?.includes(id));
    return {
        isSelected,
        toggleSelected,
        enableSelectShifts,
        someShiftsSelected: !!selectedShifts?.length,
        allShiftsSelected: ids.every((id) => selectedShifts?.includes(id)) && !!ids.length,
    };
};
exports.useSelectedShifts = useSelectedShifts;
const useSelectedDays = () => {
    const { selectedDays, setSelectedDays, enableSelectDays, days } = useSchedule();
    const lastSelectedDateRef = (0, react_1.useRef)(null);
    const isShiftPressedRef = (0, react_1.useRef)(false);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        if (e.key === 'Shift') {
            isShiftPressedRef.current = true;
        }
    }, []);
    const handleKeyUp = (0, react_1.useCallback)((e) => {
        if (e.key === 'Shift') {
            isShiftPressedRef.current = false;
        }
    }, []);
    // Set up event listeners only if enableSelectDays is true
    (0, react_1.useEffect)(() => {
        if (!enableSelectDays)
            return;
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [enableSelectDays, handleKeyDown, handleKeyUp]);
    const getDaysBetween = (0, react_1.useCallback)((startDate, endDate) => {
        // Find indices of both dates
        const startIndex = days.findIndex((day) => day.dateISO === startDate);
        const endIndex = days.findIndex((day) => day.dateISO === endDate);
        if (startIndex === -1 || endIndex === -1)
            return [];
        // Get the correct range regardless of selection direction
        const [start, end] = startIndex <= endIndex ? [startIndex, endIndex] : [endIndex, startIndex];
        // Include both start and end dates in the selection
        const selectedDays = days
            .slice(start, end + 1)
            .filter((day) => day.withinRange)
            .map((day) => day.dateISO);
        return selectedDays;
    }, [days]);
    const toggleSelected = (0, react_1.useCallback)((day) => {
        if (!enableSelectDays)
            return;
        const isShiftPressed = isShiftPressedRef.current;
        const lastSelectedDate = lastSelectedDateRef.current;
        setSelectedDays?.((curr) => {
            if (isShiftPressed && lastSelectedDate) {
                const daysBetween = getDaysBetween(lastSelectedDate, day);
                const isSelecting = !curr.includes(day);
                if (isSelecting) {
                    // Add all days between last selected and current
                    const newDays = new Set([...curr, ...daysBetween]);
                    return Array.from(newDays);
                }
                else {
                    // Remove all days between last selected and current
                    return curr.filter((d) => !daysBetween.includes(d));
                }
            }
            else {
                // Normal single day toggle
                if (curr.includes(day)) {
                    return curr.filter((selectedDay) => selectedDay !== day);
                }
                return [...curr, day];
            }
        });
        lastSelectedDateRef.current = day;
    }, [enableSelectDays, getDaysBetween, setSelectedDays]);
    const isDaySelected = (0, react_1.useCallback)((day) => !!selectedDays?.includes(day), [selectedDays]);
    return {
        isDaySelected,
        toggleSelected,
        enableSelectDays,
    };
};
exports.useSelectedDays = useSelectedDays;
